// FETCH_EVENT_GROUPINGS
import { fromJS } from "immutable";
import * as actions from "../../actions/maintenance/electronicCorrespondence";
import { START, SUCCESS, ERROR } from "../../actions/maintenance/global";
import { fetchingState } from "../../constants";

const initialState = {
	eventGroupings: { data: [], state: null },
	eventGroupingPublications: { data: [], state: null },
	supportTicketTopics: { data: [], state: null },
	supportTicketTopicFAQItems: { data: [], state: null },
};

export default (state = fromJS(initialState), action) => {
	switch (action.type) {
		case actions.FETCH_EVENT_GROUPINGS[START]:
			return state.setIn(["eventGroupings", "state"], fetchingState.FETCHING);
		case actions.FETCH_EVENT_GROUPINGS[SUCCESS]:
			return state
				.setIn(["eventGroupings", "state"], fetchingState.LOADED)
				.setIn(["eventGroupings", "data"], fromJS(action?.data?.results || []));
		case actions.FETCH_EVENT_GROUPINGS[ERROR]:
			return state.setIn(["eventGroupings", "state"], fetchingState.ERROR);
		case actions.FETCH_EVENT_FORM_PUBLICATIONS[START]:
			return state.setIn(
				["eventGroupingPublications", "state"],
				fetchingState.FETCHING,
			);
		case actions.FETCH_EVENT_FORM_PUBLICATIONS[SUCCESS]:
			return state
				.setIn(["eventGroupingPublications", "state"], fetchingState.LOADED)
				.setIn(
					["eventGroupingPublications", "data"],
					fromJS(action?.data?.results || []),
				);
		case actions.FETCH_EVENT_FORM_PUBLICATIONS[ERROR]:
			return state.setIn(
				["eventGroupingPublications", "state"],
				fetchingState.ERROR,
			);
		case actions.FETCH_SUPPORT_TICKET_TOPICS[START]:
			return state.setIn(
				["supportTicketTopics", "state"],
				fetchingState.FETCHING,
			);
		case actions.FETCH_SUPPORT_TICKET_TOPICS[SUCCESS]:
			return state
				.setIn(["supportTicketTopics", "state"], fetchingState.LOADED)
				.setIn(
					["supportTicketTopics", "data"],
					fromJS(action?.data?.results || []),
				);
		case actions.FETCH_SUPPORT_TICKET_TOPICS[ERROR]:
			return state.setIn(
				["supportTicketTopicFAQItems", "state"],
				fetchingState.ERROR,
			);
		case actions.FETCH_SUPPORT_TICKET_TOPIC_FAQ_ITEMS[START]:
			return state.setIn(
				["supportTicketTopicFAQItems", "state"],
				fetchingState.FETCHING,
			);
		case actions.FETCH_SUPPORT_TICKET_TOPIC_FAQ_ITEMS[SUCCESS]:
			return state
				.setIn(["supportTicketTopicFAQItems", "state"], fetchingState.LOADED)
				.setIn(
					["supportTicketTopicFAQItems", "data"],
					fromJS(action?.data?.results || []),
				);
		case actions.FETCH_SUPPORT_TICKET_TOPIC_FAQ_ITEMS[ERROR]:
			return state.setIn(
				["supportTicketTopicFAQItems", "state"],
				fetchingState.ERROR,
			);

		default:
			return state;
	}
};
